import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase"; // adjust path as needed
import { useI18nField } from "../locale/LocaleContext"; // adjust path as needed

// Tiny helper that reuses your i18n field reader for inline strings
function useTr() {
  const f = useI18nField();
  return (en, fr) => f({ text: { en, fr } }, "text");
}

const ContactInfo = () => {
  const [contact, setContact] = useState(null);
  const f = useI18nField();
  const tr = useTr();

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const docRef = doc(db, "contactInfo", "contact");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContact(docSnap.data());
        } else {
          console.error("No contact info found");
        }
      } catch (e) {
        console.error("Error loading contact info:", e);
      }
    };
    fetchContact();
  }, []);

  if (!contact) return null;

  // For fields that might be bilingual objects {en, fr} or plain strings,
  // prefer the localized value via `f`, else fall back to the raw string.
  const readI18n = (obj, key) => {
    const val = obj?.[key];
    if (!val) return "";
    if (typeof val === "object") return f(obj, key); // { en, fr }
    return String(val); // plain string
  };

  const address = readI18n(contact, "address");
  const hours = readI18n(contact, "hours");
  const notes = readI18n(contact, "notes"); // optional extra field if you have it

  return (
    <div className="contact-info bg-white text-black p-4 shadow rounded-lg">
      <h3 className="text-lg font-bold mb-2">
        {tr("Contact Us", "Contactez-nous")}
      </h3>

      {address && (
        <p>
          <strong>{tr("Address", "Adresse")}:</strong> {address}
        </p>
      )}

      {contact.phoneWholesale && (
        <p>
          <strong>{tr("Phone", "Téléphone")}:</strong> {contact.phoneWholesale}{" "}
          [{tr("Wholesale", "Vente en gros")}]
        </p>
      )}

      {contact.phoneShowroom && (
        <p>
          <strong>{tr("Phone", "Téléphone")}:</strong> {contact.phoneShowroom}{" "}
          [{tr("Showroom", "Salle d’exposition")}]
        </p>
      )}

      {contact.email && (
        <p>
          <strong>{tr("Email", "Courriel")}:</strong> {contact.email}
        </p>
      )}

      {hours && (
        <p>
          <strong>{tr("Working Hours", "Heures d’ouverture")}:</strong> {hours}
        </p>
      )}

      {notes && (
        <p>
          <strong>{tr("Notes", "Notes")}:</strong> {notes}
        </p>
      )}
    </div>
  );
};

export default ContactInfo;
